import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { battlePassAPI } from '../../../services/api';
import { fetchNotifications } from '../../../store/slices/countersSlice';
import i18n from '../../../i18n';

export const fetchBattlePass = createAsyncThunk(
  'battlePass/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await battlePassAPI.getBattlePass();
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const claimTier = createAsyncThunk(
  'battlePass/claim',
  async ({ tierId, track }, { rejectWithValue, dispatch }) => {
    try {
      const idempotencyKey = `bp-${tierId}-${track}-${Date.now()}`;
      const result = await battlePassAPI.claimTier(tierId, track, idempotencyKey);
      // Refresh state so claimed status updates
      dispatch(fetchBattlePass());
      // BattlePass badge (home screen pill) reads counters.battlePass
      dispatch(fetchNotifications());
      return { tierId, track, result };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  season: null,
  userProgress: null,
  tiers: [],
  isLoading: false,
  claimingKey: null,
  error: null,
};

const battlePassSlice = createSlice({
  name: 'battlePass',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBattlePass.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBattlePass.fulfilled, (state, action) => {
        state.isLoading = false;
        state.season = action.payload.season;
        state.userProgress = action.payload.userProgress;
        state.tiers = action.payload.tiers || [];
      })
      .addCase(fetchBattlePass.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t('battlepass.load_failed', 'Failed to load BattlePass');
      })
      .addCase(claimTier.pending, (state, action) => {
        state.claimingKey = `${action.meta.arg.tierId}|${action.meta.arg.track}`;
        state.error = null;
      })
      .addCase(claimTier.fulfilled, (state) => {
        state.claimingKey = null;
      })
      .addCase(claimTier.rejected, (state, action) => {
        state.claimingKey = null;
        state.error = action.payload || i18n.t('lair.toast.claim_failed', 'Failed to claim');
      });
  },
});

export const { clearError } = battlePassSlice.actions;
export default battlePassSlice.reducer;
